import React, { useEffect } from 'react';
import ScimErrorBanner from 'features/scim-management/components/ScimErrorBanner';
import ScimGroupList from 'features/scim-management/components/ScimGroupList';
import { epochTimeIsPast } from 'react-oauth2-code-pkce/timeUtils';

function isPlatformTokenValid(): boolean {
  const token = localStorage.getItem('ROCP_token')?.replace(/^"|"$/g, '') ?? '';
  if (token === '') return false;

  const expireRaw = localStorage.getItem('ROCP_tokenExpire');
  if (expireRaw !== null) {
    const expireTimestamp = Number(expireRaw);
    if (!Number.isNaN(expireTimestamp) && epochTimeIsPast(expireTimestamp)) {
      return false;
    }
  }

  return true;
}

function redirectToPlatformAuth(): void {
  localStorage.setItem('lastVisitedUrl', '/scim-management');
  window.location.href = '/platform-auth';
}

export default function ScimManagementView(): JSX.Element {
  useEffect(() => {
    if (!isPlatformTokenValid()) {
      redirectToPlatformAuth();
      return;
    }

    const interval = setInterval(() => {
      if (!isPlatformTokenValid()) {
        redirectToPlatformAuth();
      }
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="p-6 pb-20 space-y-6 w-full">
      <ScimErrorBanner />
      <h1 className="text-dataops-dark text-xl">SCIM Management</h1>
      <div className="flex gap-6">
        <div className="flex-1 space-y-4">
          <ScimGroupList />
        </div>
      </div>
    </div>
  );
}
